// src/components/Calculator.js
import React, { useState, useEffect } from 'react';

// Definimos las tarifas y descripciones (Lógica)
const RATES = {
    normal: 8.55,
    express: 7.55,
};

const DESCRIPTIONS = {
    normal: {
        title: "Categoría 4x4: hasta 4 kg y $400 de valor total",
        details: [
            "Tiempo de entrega: Contamos con +6 fechas de vuelo al mes, actualizadas en nuestra cuenta de Instagram @kifli.ec para la llegada de tus paquetes.",
            "Tarifa: $8,55 por libra *Valor final (incluye IVA y Arancel)",
            "Proceso de importación ágil, priorizado y personalizado",
            "¡Perfecto para compras urgentes!"
        ]
    },
    express: {
        title: "Categoría 4x4: hasta 4 kg y $400 de valor total",
        details: [
            "Tiempo de entrega: 7 días laborables (Una vez que tu compra llegue a nuestra bodega en Miami)",
            "Tarifa: $7,55 por libra *Valor final (incluye IVA y Arancel)",
            "Pasa por Aduana en Ecuador",
            "¡Ideal si quieres ahorrar sin apuros!"
        ]
    }
};

function Calculator() {
    const [service, setService] = useState('normal');
    const [pounds, setPounds] = useState(''); // Variable para tu input 'libras'
    const [total, setTotal] = useState(0); // Variable para tu 'totalCost'

    // Lógica de cálculo (sin cambios)
    useEffect(() => {
        const weight = parseFloat(pounds) || 0; 
        const rate = RATES[service];
        const newTotal = weight * rate;
        setTotal(newTotal);
    }, [pounds, service]);

    const handlePoundsChange = (e) => {
        setPounds(e.target.value);
    };

    const currentDescription = DESCRIPTIONS[service];

    return (
        <div className="bg-[#292929] text-white pt-5 px-5 pb-3 md:pt-6 md:px-6 md:pb-3
 rounded-2xl shadow-2xl max-w-lg mx-auto z-10 relative">

            <h2 className="text-2xl font-bold text-center mb-1">
                Calculadora de Envíos
            </h2>

            {/* --- 1. Selector de Servicio --- */}
            <div className="flex justify-center gap-2 mb-4">
                <button
                onClick={() => setService('normal')}
                className={`form-button py-1.5 px-4 text-sm ${
                    service === 'normal'
                    ? 'bg-lime-400 text-black'
                    : 'bg-gray-600 text-white'
                }`}
                >
                Servicio PRO
                </button>

                <button
                onClick={() => setService('express')}
                className={`form-button py-1.5 px-4 text-sm ${
                    service === 'express'
                    ? 'bg-lime-400 text-black'
                    : 'bg-gray-600 text-white'
                }`}
                >
                Servicio KIFLIX
                </button>
            </div>

            {/* --- 2. Input de Peso --- */}
            <div className="relative mb-4">
                <input
                type="number"
                value={pounds}
                onChange={handlePoundsChange}
                placeholder="0.00"
                className="w-full bg-[#222222] text-lime-400 text-3xl font-bold text-center p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-lime-400 no-arrows"
                />
                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-lg font-bold text-gray-500">
                lbs
                </span>
            </div>

            {/* --- 3. Descripción del Servicio --- */}
            <div className="bg-[#222222] p-3 rounded-lg mb-4">
                <h4 className="text-sm font-bold text-lime-400 mb-1 text-center">
                {currentDescription.title}
                </h4>
                <ul className="list-disc list-inside space-y-0.5 text-xs text-gray-300">
                {currentDescription.details.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
                </ul>
            </div>

            {/* --- 4. Total --- */}
            <div className="flex justify-between items-center mb-4 text-lg">
                <span className="font-light">Total:</span>
                <span className="font-bold text-lime-400">
                ${total.toFixed(2)}
                </span>
            </div>

            {/* --- 5. Botón --- */}
            <a
                href="https://api.whatsapp.com/send/?phone=593982968185&text&type=phone_number&app_absent=0"
                className="form-button bg-lime-400 text-black hover:bg-white hover:text-lime-400 w-full py-2.5 block text-center text-sm"
            >
                Contactar Asesor
            </a>

            {/* --- 6. Texto adicional --- */}
            <p className="text-center text-gray-400 mt-1 text-xs">
                Nuestro Servicio de Importación: Desde Miami a Ecuador
            </p>

        </div>
    );
}

export default Calculator;
